<template>
    <div>
      <div class="w-full vx-col mb-base">
        <vs-card title="Add New Product" class="p-4 mb-6">
          <div slot="header" class="flex flex-wrap items-center justify-between">
            <div class="flex items-center">
              <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
              <h4 style="margin-left: 10px">View Product</h4>
            </div>
            <div class="flex items-center">
                  <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="submitForm" icon="save" v-show="editMode">Save</vs-button>
                  <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="editForm" icon="edit" v-show="!editMode">Edit</vs-button>
                  <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="printPopup = true" icon="print">Print Label</vs-button>
              </div>
          </div>
          <div class="mt-6 vx-row">
            <div class="w-full vx-col md:w-1/2">
              <div class="mb-3 vx-row">
                <div class="w-full vx-col">
                  <vs-input disabledd class="w-full" v-model="data.id" :disabled="true" :hidden="true" />
                </div>
              </div>
              <div class="mb-3 vx-row">
                <div class="w-full vx-col">
                  <vs-input class="w-full" label="Product ID *" v-model="data.product_code" :disabled="!editMode" />
                </div>
              </div>
              <div class="mb-3 vx-row">
                <div class="w-full vx-col">
                  <vs-input class="w-full" label="Description" v-model="data.description_1" :disabled="!editMode" />
                </div>
              </div>
              <div class="mb-3 vx-row">
                <div class="w-full vx-col">
                  <vs-input class="w-full" v-model="data.description_2" :disabled="!editMode" />
                </div>
              </div>
            </div>
            <div class="w-full vx-col md:w-1/2">
              <div class="mb-3 vx-row">
                <div class="w-full vx-col">
                  <label for class="vs-input--label">Client *</label>
                  <v-select
                    :options="clientsOptions"
                    v-model="data.client_id"
                    label="client_code"
                    :clearable="false"
                    :disabled="!editMode"
                  ></v-select>
                </div>
              </div>
              <div class="mb-3 vx-row">
                <div class="w-full vx-col">
                   <label for="" class="vs-input--label">Product Category *</label>
                  <v-select :options="productcategoryOptions" v-model="data.product_categories_id" label="name"  :clearable="false" :disabled="!editMode"></v-select>
                </div>
              </div>

              <div class="mb-3 vx-row">
                  <div class="w-full vx-col">
                      <label for class="vs-input--label">Storage Type</label>
                      <v-select
                          :options="storage_type"
                          v-model="data.storage_type"
                          :clearable="false"
                          :disabled="!editMode"
                      ></v-select>
                  </div>
              </div>

              <div class="mb-3 flex items-center">
                  <div class="mr-8">
                      <label for="" class="vs-input--label" >Status </label>
                      <vs-switch class="mt-2" v-model="data.is_active" :disabled="!editMode">
                          <span slot="on">Active</span>
                          <span slot="off">Deactive</span>
                      </vs-switch>
                  </div>
                  <div class="mr-8">
                      <label for="" class="vs-input--label" >Stock GINEE </label>
                      <vs-switch class="mt-2" v-model="data.is_ginee" :disabled="!editMode">
                          <span slot="on">YES</span>
                          <span slot="off">NO</span>
                      </vs-switch>
                  </div>
                  <div>
                      <label for="" class="vs-input--label" >Product Bundling </label>
                      <vs-switch class="mt-2" v-model="data.is_virtual_bundling" :disabled="!editMode">
                          <span slot="on">YES</span>
                          <span slot="off">NO</span>
                      </vs-switch>
                  </div>
              </div>

            </div>
          </div>

          <vs-tabs class="mt-6" :key="data.is_virtual_bundling">
            <vs-tab label="Unit of Measure">
               <div class="mt-8 vx-row">
                  <div class="w-full vx-col lg:w-1/2">
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Base UoM
                          </div>
                          <div class="w-2/3 vx-col">
                              <v-select :options="UomOption" v-model="default_uom.uom_id" label="name" :clearable="false" :disabled="!editMode"></v-select>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Base Volume
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col sm:mb-1">
                                <vs-input class="w-full" v-model="default_uom.base_volume" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <v-select :options="UomVolume" v-model="default_uom.uom_volume_id" label="name"  :disabled="!editMode"></v-select>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Base Gross Weight
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col sm:mb-1">
                                <vs-input class="w-full" v-model="default_uom.base_gw" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <v-select :options="UomWeight" v-model="default_uom.uom_gw_id" label="name"  :disabled="!editMode" @input="changeUomWeight()"></v-select>
                              </div>
                            </div>
                          </div>

                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Base Net Weight
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col sm:mb-1">
                                <vs-input class="w-full" v-model="default_uom.base_nw" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <v-select :options="UomWeight" v-model="default_uom.uom_nw_id" label="name" :disabled="true"></v-select>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
                  <div class="w-full vx-col lg:w-1/2">
                     <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Barcode
                          </div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="default_uom.barcode" :disabled="!editMode"/>
                          </div>
                      </div>
                       <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Dimension
                          </div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="default_uom.dimension" :disabled="!editMode"/>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">Length</div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="default_uom.length" v-on:keyup="calculateCubic" :disabled="!editMode"/>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">Width</div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="default_uom.width" v-on:keyup="calculateCubic" :disabled="!editMode"/>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">Height</div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="default_uom.height" v-on:keyup="calculateCubic" :disabled="!editMode"/>
                          </div>
                      </div>

                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">(Length * Width * Height)</div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="default_uom.cubic" :disabled="true"/>
                          </div>
                      </div>
                  </div>
              </div>
              <vs-divider border-style="solid" class="mt-8">PRODUCT UOM</vs-divider>
               <div class="vx-row">
                <div class="w-full mb-4 vx-col">
                   <vs-button color="primary" size="sm" class="mb-4 mr-1 btn md:mb-0" @click="addUom" :disabled="!editMode">Add</vs-button>
                   <vs-button color="primary" size="sm" class="mb-4 btn md:mb-0" @click="removeUom" :disabled="uom_selected.length <= 0 || !editMode">Remove</vs-button>
                </div>
                <div class="w-full vx-col">
                  <vs-table v-model="uom_selected" :data="uom_list" stripe multiple hoverFlat>
                      <template slot="thead">
                          <vs-th>Uom</vs-th>
                          <vs-th>Numerator</vs-th>
                          <vs-th>Denominator</vs-th>
                          <vs-th>Barcode</vs-th>
                          <vs-th>Dimension</vs-th>
                          <vs-th>Length</vs-th>
                          <vs-th>Width</vs-th>
                          <vs-th>Height</vs-th>
                          <vs-th>(Length * Width * Height)</vs-th>
                      </template>

                      <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                              <vs-td>
                                  <vs-select
                                      v-model="tr.uom_id"
                                      width="100%"
                                      :disabled="!editMode"
                                  >
                                      <vs-select-item v-for="(item, index) in UomOption" :key="index" :value="item.id" :text="item.name" />
                                  </vs-select>
                              </vs-td>

                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.numerator" :disabled="!editMode"/>
                              </vs-td>

                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.denominator" :disabled="!editMode"/>
                              </vs-td>

                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.barcode" :disabled="!editMode"/>
                              </vs-td>

                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.dimension" :disabled="!editMode"/>
                              </vs-td>

                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.length" :disabled="!editMode" @keyup="calculateCubicTr(tr)"/>
                              </vs-td>
                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.width" :disabled="!editMode" @keyup="calculateCubicTr(tr)"/>
                              </vs-td>
                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.height" :disabled="!editMode" @keyup="calculateCubicTr(tr)"/>
                              </vs-td>
                              <vs-td>
                                  <vs-input class="w-full" v-model="tr.cubic" :disabled="true"/>
                              </vs-td>

                          </vs-tr>
                      </template>
                  </vs-table>

                </div>

               </div>
            </vs-tab>
            <vs-tab label="WM Configuration">

              <div class="mt-8 vx-row">
                  <div class="w-full vx-col lg:w-1/2">
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Storage Quantity
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.storage_quantity" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.storage_quantity_1" :disabled="true"/>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Replenish Quantity
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.replenish_quantity" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.replenish_quantity_1" :disabled="true"/>
                              </div>
                            </div>
                          </div>

                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Minimum Quantity
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.minimum_quantity" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.minimum_quantity_1" :disabled="true"/>
                                <!-- <vs-input class="w-full" v-model="vm_config.fixed_rate"/> -->
                              </div>
                            </div>
                          </div>
                      </div>
                       <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Maximum Quantity
                          </div>
                          <div class="w-2/3 vx-col">
                            <div class="vx-row">
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.maximum_quantity" :disabled="!editMode"/>
                              </div>
                              <div class="w-1/2 vx-col">
                                <vs-input class="w-full" v-model="vm_config.maximum_quantity_1" :disabled="true"/>
                                <!-- <vs-input class="w-full" v-model="vm_config.fixed_rate"/> -->
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>
                  <div class="w-full vx-col lg:w-1/2">
                     <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Default Location Type ID
                          </div>
                          <div class="w-2/3 vx-col">
                              <v-select :options="defaultLocationTypesOption" v-model="vm_config.default_location_type_id" label="code"  :clearable="false" :disabled="!editMode"></v-select>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              CAB Location ID
                          </div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="vm_config.cab_location_id" :disabled="!editMode"/>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Pick Location ID
                          </div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="vm_config.pick_location_id" :disabled="!editMode"/>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              BULK Location ID
                          </div>
                          <div class="w-2/3 vx-col">
                              <vs-input class="w-full" v-model="vm_config.bulk_location_id" :disabled="!editMode"/>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Section
                          </div>
                          <div class="w-2/3 vx-col">
                              <v-select :options="sectionOption" v-model="vm_config.section_id" label="section_code"  :clearable="false" :disabled="!editMode"></v-select>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Put Strategy
                          </div>
                          <div class="w-2/3 vx-col">
                              <v-select :options="putOption" v-model="vm_config.put_strategy_id" label="name"  :clearable="false" :disabled="!editMode"></v-select>
                          </div>
                      </div>
                      <div class="mb-3 vx-row">
                          <div class="w-1/3 vx-col">
                              Pick Strategy
                          </div>
                          <div class="w-2/3 vx-col">
                              <v-select :options="pickOption" v-model="vm_config.pick_strategy_id" label="name"  :clearable="false" :disabled="!editMode"></v-select>
                          </div>
                      </div>
                  </div>
              </div>
            </vs-tab>

            <vs-tab label="VAS">
               <div class="mt-8 vx-row">
                <div class="w-full mb-4 vx-col">
                  <vs-button
                    color="primary"
                    size="sm"
                    class="mb-4 mr-1 btn md:mb-0"
                    @click="addProductVas"
                    :disabled="!editMode"
                  >Add</vs-button>
                  <vs-button
                    color="primary"
                    size="sm"
                    class="mb-4 btn md:mb-0"
                    @click="removeProductVas"
                    :disabled="product_vas_selected.length <= 0 || !editMode"
                  >Remove</vs-button>
                </div>
                <div class="w-full vx-col">
                  <vs-table v-model="product_vas_selected" :data="product_vas" stripe multiple hoverFlat>
                    <template slot="thead">
                      <vs-th>Product ID</vs-th>
                      <vs-th>Description</vs-th>
                      <vs-th>Base Qty</vs-th>
                      <vs-th>Base Unit</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          <vs-select v-model="tr.product_id" @input="changeProductVas(tr)" :disabled="!editMode">
                            <vs-select-item
                              v-for="(item, index) in productOption"
                              :key="index"
                              :value="item.id"
                              :text="item.product_code"
                            />
                          </vs-select>
                        </vs-td>

                        <vs-td>
                          <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                        </vs-td>

                        <vs-td>
                          <vs-input class="w-full" v-model="tr.base_qty" :disabled="!editMode"/>
                        </vs-td>

                        <vs-td>
                          <vs-input class="w-full" v-model="tr.base_unit" :disabled="true"/>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Manufacturing">
            </vs-tab>
            <vs-tab label="Notes">
            </vs-tab>
            <vs-tab label="Attachment">
            </vs-tab>
            <vs-tab label="Virtual Bundling" v-if="data.is_virtual_bundling">
                <div class="mt-8 vx-row">
                    <div class="w-full mb-4 vx-col">
                        <vs-button
                            color="primary"
                            size="sm"
                            class="mb-4 mr-1 btn md:mb-0"
                            @click="addProductBundling"
                            :disabled="!editMode"
                        >Add</vs-button>
                        <vs-button
                            color="primary"
                            size="sm"
                            class="mb-4 btn md:mb-0"
                            @click="removeProductBundling"
                            :disabled="product_bundling_selected.length <= 0 || !editMode"
                        >Remove</vs-button>
                    </div>
                    <div class="w-full vx-col">
                        <vs-table v-model="product_bundling_selected" :data="product_bundling" stripe multiple hoverFlat>
                            <template slot="thead">
                                <vs-th>Product ID</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Base Qty</vs-th>
                                <vs-th>Base Unit</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>
                                        <vs-select v-model="tr.product_id" @input="changeProductBundling(tr)" :disabled="!editMode">
                                        <vs-select-item
                                            v-for="(item, index) in productOption"
                                            :key="index"
                                            :value="item.id"
                                            :text="item.product_code"
                                        />
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.base_qty" :disabled="!editMode" />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="tr.base_unit" :disabled="true"/>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </vs-tab>
          </vs-tabs>

        </vs-card>
      </div>
      <vs-prompt @accept="printLabel" title="Print Product Label" :active.sync="printPopup">
          <div class="con-exemple-prompt">
              <vs-input
                  placeholder="Qty"
                  v-model="printQty"
                  class="w-full mb-4"
              />
          </div>
      </vs-prompt>
    </div>
  </template>

  <script>
  import vSelect from "vue-select";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    components: {
      vSelect,
      flatPickr,
    },
    data() {
      return {
          printQty: 1,
          printPopup: false,
         isLoading: false,
         editMode:false,
        data: {
          id: "",
          is_active:true,
          is_ginee:false,
          is_virtual_bundling:false,
          product_code: "",
          description_1: "",
          description_2: "",
          client_id: null,
          product_categories_id: null,
          storage_type:'Fulfillment',
          // client_id: this.$store.state.user.userconfig.client,
          // product_categories_id: this.$store.state.user.userconfig.product_categories,
        },

          // Default Uom
        default_uom:{
          uom_id:null,
          // uom_id:this.$store.state.user.userconfig.part_uom,
          base_volume:0,
          uom_volume_id:null,
          base_nw:0,
          uom_nw_id:null,
          base_gw:0,
          uom_gw_id:null,
          barcode:'',
          dimension:'',
          length:0,
          width:0,
          height:0,
          cubic:0,
        },

        // VM Configuration
        vm_config :{
          storage_quantity:0,
          replenish_quantity:0,
          minimum_quantity:0,
          maximum_quantity:0,

          storage_quantity_1:'',
          replenish_quantity_1:'',
          minimum_quantity_1:'',
          maximum_quantity_1:'',

          default_location_type_id:null,
          cab_location_id:0,
          pick_location_id:0,
          bulk_location_id:0,
          section_id:null,
          // section_id:this.$store.state.user.userconfig.section,
          put_strategy_id:null,
          pick_strategy_id:null,
        },

        product_vas:[],
        product_vas_selected:[],
        product_bundling:[],
        product_bundling_selected:[],

        // uoms list
        uom_list:[],
        uom_selected:[],

        UomOption:[],
        UomVolume:[],
        UomWeight:[],
        defaultLocationTypesOption:[],
        clientsOptions: [],
        productcategoryOptions: [],
        productOption: [],
        sectionOption:[],
        pickOption:[],
        putOption:[],
        storage_type: ['Fulfillment','Conventional'],
        maxRetry: 10
      };
    },
    watch: {
      'data.is_virtual_bundling': function(val) {
        if (!val) {
          this.product_bundling = [];
          this.product_bundling_selected = [];
        }
      },
      isLoading: function() {
        if (this.isLoading) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      changeProductBundling(data){
          let prd = this.productOption.filter((item)=>{
            if (item.id == data.product_id){
                return item
              }
          });
          data.description = prd[0].description_1
          data.base_unit = prd[0].base_uom.uom.name
      },
      removeProductBundling(){
        this.product_bundling_selected.map((item1, index1) => {
          this.product_bundling.map((item, index) => {
            if (item == item1) {
              this.product_bundling.splice(index, 1);
            }
          });
        });
        this.product_bundling_selected = [];
      },
      addProductBundling(){
          if(this.data.client_id == null){
            this.$vs.notify({
              color: "danger",
              title: "Product Virtual Bundling Error",
              text: "Please insert client data",
            });
            return false;
          }

          if(this.productOption.length == 0){
            this.isLoading = true
            this.$http.post('master/product/showbyclient',{ client_code: this.data.client_id.client_code })
            .then((resp)=> {
              this.productOption.push(resp.data.data)
              this.product_bundling.push({
                product_id:null,
                description:'',
                base_qty:0,
                base_unit:''
              })
              this.isLoading = false
            })
          }
          else {
            this.product_bundling.push({
                product_id:null,
                description:'',
                base_qty:0,
                base_unit:''
            })
          }
      },
      changeProductVas(data){
          //  console.log(data.product_id)
          let prd = this.productOption.filter((item)=>{
            if (item.id == data.product_id){
                return item
              }
          });
          data.description = prd[0].description_1
          data.base_unit = prd[0].base_uom.uom.name
      },
      removeProductVas(){
        this.product_vas_selected.map((item1, index1) => {
          this.product_vas.map((item, index) => {
            if (item == item1) {
              this.product_vas.splice(index, 1);
            }
          });
        });
        this.product_vas_selected = [];
      },
      addProductVas(){
          if(this.data.client_id == null){
            this.$vs.notify({
                  color: "danger",
                  text: "Client id field required"
                });
            return false;
          }
          if(!this.productOption.length) {
            this.$http.post('master/product/showbyclient',{ client_code: this.data.client_id.client_code })
            .then((resp)=> {
              this.productOption.push(resp.data.data)
              this.product_vas.push({
                product_id:null,
                description:'',
                base_qty:0,
                base_unit:''
              })
            })
            .catch((error)=>{
              console.log(error)
            })
          }
          else {
            this.product_vas.push({
                product_id:null,
                description:'',
                base_qty:0,
                base_unit:''
              })
          }
      },
      changeUomWeight(){
          this.default_uom.uom_nw_id = this.default_uom.uom_gw_id
      },
      addUom(){
        let obj = {
              uom_id:null,
              numerator:0,
              denominator:0,
              barcode:0,
              dimension:0,
              length: 0,
              width: 0,
              height: 0,
              status:'insert',
              cubic: 0,
          };
        this.uom_list.push(obj);
      },
      removeUom(){
          this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: 'Remove Data ?',
              text: 'Are you sure want to remove selected data ?',
              accept: () => {

                  this.uom_selected.map((item1, index1) => {
                    this.uom_list.map((item, index) => {
                        if(item == item1){
                          this.uom_list.splice(index, 1);
                        }
                    })
                  });
                  this.uom_selected = [];

              },
              cancel: () => { return; },
              acceptText: 'Yes',
              cancelText: 'No'
        });

      },
      fetchData() {
        this.isLoading = true;
        this.maxRetry = this.maxRetry - 1;
        this.$http.all([
          this.$http.get("master/product/" + this.$route.params.id),
        ])
          .then(this.$http.spread((single) => {
            let data = single.data;
            this.data = data.product
            this.data.is_active = data.product.is_active == 1 ? true : false
            this.data.is_ginee = data.product.is_ginee == 1 ? true : false
            this.data.is_virtual_bundling = data.product.is_virtual_bundling == 1 ? true : false
            this.uom_list = data.uoms

            this.productcategoryOptions = [data.product.productcategories]
            this.data.product_categories_id = data.product.productcategories
            this.data.storage_type = data.product.storage_type

            this.clientsOptions = [data.product.clients]
            this.data.client_id = data.product.clients

            if(data.default_uom != null){
              this.default_uom = data.default_uom
              this.UomOption = [data.default_uom.uom]
              this.default_uom.uom_id = data.default_uom.uom
              this.UomVolume = [data.default_uom.uom_volume]
              this.default_uom.uom_volume_id = data.default_uom.uom_volume
              this.UomWeight = [data.default_uom.uom_nw]
              this.default_uom.uom_nw_id = data.default_uom.uom_nw
              this.default_uom.uom_gw_id = data.default_uom.uom_gw
              this.default_uom.length = data.default_uom.length
              this.default_uom.width = data.default_uom.width
              this.default_uom.height = data.default_uom.height
              this.default_uom.storage_type = data.default_uom.storage_type
              this.default_uom.cubic = data.default_uom.cubic
            }

            if(data.vmconfiguration != null){
              this.defaultLocationTypesOption = [data.vmconfiguration.location_type]
              this.vm_config.default_location_type_id = data.vmconfiguration.location_type

              this.sectionOption = [data.vmconfiguration.section]
              this.vm_config.section_id = data.vmconfiguration.section

              this.pickOption = [data.vmconfiguration.pick_strategy]
              this.vm_config.pick_strategy_id = data.vmconfiguration.pick_strategy

              this.putOption = [data.vmconfiguration.put_strategy]
              this.vm_config.put_strategy_id = data.vmconfiguration.put_strategy

              this.vm_config.storage_quantity = data.vmconfiguration.storage_quantity
              this.vm_config.replenish_quantity = data.vmconfiguration.replenish_quantity
              this.vm_config.minimum_quantity = data.vmconfiguration.minimum_quantity
              this.vm_config.maximum_quantity = data.vmconfiguration.maximum_quantity
            }

            if(data.uoms.length >0){
                data.uoms.map((item) => {
                  this.UomOption.push(item.uom);
                })
            }

            data.product.boms.map((item)=>{
                this.productOption.push(item)
                this.product_vas.push({
                  product_id:item.id,
                  description:item.description_1,
                  base_qty:item.pivot.qty,
                  base_unit:item.base_uom.uom.name,
                })
            })

            data.product.bundlings.map((item)=>{
                this.productOption.push(item)
                this.product_bundling.push({
                  product_id:item.id,
                  description:item.description_1,
                  base_qty:item.pivot.qty,
                  base_unit:item.base_uom.uom.name,
                })
            })

            this.UomVolume = this.UomWeight = this.UomOption
            this.clientsOptions = [data.product.clients]


              // defaultLocationTypesOption:[],
              // sectionOption:[],

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          }))
          .catch((error) => {
            // console.log(error)
            // alert(error)
            if (this.maxRetry == 0) {
              this.isLoading = false;
              this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Server Error",
                text: "Try again?",
                accept: () => {
                  this.fetchData();
                  this.maxRetry = 10;
                },
                cancel: () => this.$router.go(-1),
                acceptText: "Yes",
                cancelText: "No"
              });
              return;
            }
            this.fetchData();
          });
      },
      submitForm() {

        if (this.uom_list.length > 0) {
          for (const [index, item] of this.uom_list.entries()) {
            if (item.uom_id == null) {
                this.$vs.notify({
                  color: "danger",
                  text: "Please, Fill all uom field on product uom"
              });
              return false;
            }
          }
        }

        if(this.default_uom.uom_id == null){
          this.$vs.notify({
            color: "danger",
            text: "Base uom field required on Unit of Measure"
          });
          return false ;
        }

         if(this.product_vas.length > 0){
            for (const [index, item] of this.product_vas.entries()) {
              if(item.product_id == null){
                 this.$vs.notify({
                    color: "danger",
                    text: "Product VAS, Product ID is required"
                  });
                return false;
              }
              if(item.base_qty <= 0){
                 this.$vs.notify({
                    color: "danger",
                    text: "Product VAS qty must be higher than 0"
                  });
                return false;
              }
            }
        }



        this.isLoading = true;

        let data = {}
        let prd = Object.assign({},this.data)
        prd.is_active = this.data.is_active == true ? 1 : 2
        prd.is_ginee = this.data.is_ginee == true ? 1 : 2
        prd.is_virtual_bundling = this.data.is_virtual_bundling == true ? 1 : 2
        prd.client_id = this.data.client_id.id
        prd.product_categories_id = this.data.product_categories_id.id
        prd.storage_type = this.data.storage_type

        if(this.default_uom != null){
            let du = Object.assign({},this.default_uom)
            du.uom_id = this.default_uom.uom_id.id
            du.uom_volume_id = this.default_uom.uom_volume_id != null ? this.default_uom.uom_volume_id.id : null
            du.uom_nw_id = this.default_uom.uom_nw_id != null ? this.default_uom.uom_nw_id.id : null
            du.uom_gw_id = this.default_uom.uom_gw_id != null ? this.default_uom.uom_gw_id.id : null
            du.length = this.default_uom.length
            du.width = this.default_uom.width
            du.height = this.default_uom.height

            data.default_uom = JSON.stringify(du)
        }

        if(this.vm_config != null){
          let vc = Object.assign({}, this.vm_config)
          vc.default_location_type_id = this.vm_config.default_location_type_id != null ? this.vm_config.default_location_type_id.id : null
          vc.section_id = this.vm_config.section_id != null ? this.vm_config.section_id.id : null
          vc.pick_strategy_id = this.vm_config.pick_strategy_id != null ? this.vm_config.pick_strategy_id.id : null
          vc.put_strategy_id = this.vm_config.put_strategy_id != null ? this.vm_config.put_strategy_id.id : null
          data.vmconfiguration = JSON.stringify(vc)
        }

        data.product_vas = JSON.stringify(this.product_vas);
        data.product_bundlings = JSON.stringify(this.product_bundling);
        data.product = JSON.stringify(prd);
        data.uoms = JSON.stringify(this.uom_list);


        this.$http.put("master/product/" + this.$route.params.id + "/update", data)
          .then(() => {
            this.$vs.notify({
              color: "success",
              title: "Saved Successfully",
              iconPack: "feather",
              icon: "icon-check",
              text: "Product updated successfully"
            });
            this.$router.push({ path: "/master/product" });
          })
          .catch((error) => {
            this.isLoading = false;
            for (const [index, err] of error.response.data.entries()) {
              this.$vs.notify({
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                text: "" + err
              });
            }
          })
          .then(() => {
            this.isLoading = false;
          });
      },
      back() {
        if (this.editMode) {
          this.$vs.dialog({
            color: "warning",
            title: "Leave Page",
            text: "Changes you made may not be saved?",
            acceptText: "Leave Page",
            accept: () => {
              this.$router.go(-1);
            }
          });
        } else {
          this.$router.go(-1);
        }
      },
      editForm() {
        this.editMode = true;
        this.isLoading = true;

          this.$http.all([
          this.$http.post("master/clients"),
          //this.$http.post('master/productcategories'),
          this.$http.post('master/productcategorieslov'),
          this.$http.post('master/uom'),
          this.$http.post('master/uov'),
          this.$http.post('master/uow'),
          this.$http.post('master/locationtypes'),

          this.$http.post('master/sections'),
          this.$http.get('master/movementstrategygetpick'),
          this.$http.get('master/movementstrategygetput'),
          this.$http.post('master/product/showbyclient',{ client_code: this.data.client_id.client_code })
          ])
          .then(this.$http.spread((clients, productcategories, uoms,uovs,uows, locationtypes, sections, mosput,mospick, products) => {

            this.clientsOptions = this.productcategoryOptions = this.UomOption = this.UomOption = this.UomVolume =  []
            this.UomWeight = this.defaultLocationTypesOption = this.sectionOption = this.putOption = this.pickOption = []

              this.clientsOptions = clients.data.data
              this.productcategoryOptions = productcategories.data.data
              this.UomOption = uoms.data.data
              this.UomVolume = uovs.data.data
              this.UomWeight = uows.data.data
              this.defaultLocationTypesOption = locationtypes.data.data
              this.sectionOption = sections.data.data
              this.putOption = mosput.data
              this.pickOption = mospick.data
              this.productOption = products.data.data

              setTimeout(() => {
                  this.isLoading = false
              }, 500)
          }))
          .catch((error) => {
              console.log(error)
              // if(this.maxRetry == 0){
              //     this.isLoading = false
              //     this.$vs.dialog({
              //         type: 'confirm',
              //         color: 'danger',
              //         title: 'Server Error',
              //         text: 'Try again?',
              //         accept: () => {
              //             this.maxRetry = 10
              //         },
              //         cancel: () => this.$router.go(-1),
              //         acceptText: 'Yes',
              //         cancelText: 'No'
              //     });
              //     return;
              // }
          })
      },
      printLabel() {
          const data = {
              id: this.$route.params.id,
              qty: parseInt(this.printQty)
          };

          this.isLoading = true;
          this.$http.post('master/product/printlabel', data, { responseType: 'blob' })
          .then(res => {
              this.isLoading = false;
              var blob = new Blob([res.data], {
                  type: 'application/pdf'
              });

              window.open(URL.createObjectURL(blob));
          })
          .catch(error => this.handleError());
      },
        calculateCubic(){
            this.default_uom.cubic = (this.default_uom.length * this.default_uom.width * this.default_uom.height)/1000000;
        },
        calculateCubicTr : function(data){
            data.cubic = (data.length * data.width * data.height)/1000000;
        },

    },
    mounted() {
      this.fetchData();
    }
  };
  </script>
